import React, {Component} from "react"
import {Toast, ListView} from 'antd-mobile';
import { myList} from "../../service/addLines";
import './style.less';
const notOrder = require('../../common/image/notOrder.png');
const dataError = require('../../common/image/dataError.png');
let pageIndex = 1;
let TYPE = 98;
let pageSize = 10;
export default class SoldOut extends Component {
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            data: [],
            total: 0,
            isLoading: true,
            dataSource,
            notDataLoading:0,
        }
    }

    componentDidMount() {
        this.getOrderList();
    }
    getOrderList() {
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data:{
                status: TYPE,
                pageSize: pageSize,
                pageNum: 1,
            }
        };
        Toast.loading("正在加载", 0);
        myList(params).then((res) => {
            pageIndex = 1;
            if (res.data.code === '0000') {
                Toast.hide();
                if(res.data.data.list.length > 0){
                    this.setState({
                        data:res.data.data.list,
                        total: res.data.data.total
                    });
                    this._setDataSource(this.state.data);
                    if (pageIndex * pageSize >= this.state.total) {
                        this.setState({isLoading: false });
                    }
                }else{
                    this.setState({isLoading: false,notDataLoading:1});
                }
            } else{
                Toast.info(res.data.msg,3);
                this.setState({isLoading: false,notDataLoading:2});
            }
        })
    };

    //拼接数据
    _setDataSource(dataSource) {
        if (!dataSource) return false;
        this.setState({
            dataSource: this.state.dataSource.cloneWithRows(dataSource),
        });
    };

    //上拉加载
    _onEndReached = () => {
        if (pageIndex * pageSize >= this.state.total) {
            this.setState({
                isLoading: false,
            });
            return false;
        }
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data:{
                status: TYPE,
                pageSize: pageSize,
                pageNum: ++pageIndex,
            }
        };
        myList(params).then((res) => {
            if (res.data.code === '0000') {
                const allData = [...this.state.data, ...res.data.data.list];
                this._setDataSource(allData);
                this.setState({
                    data: allData,
                    total: res.data.data.total
                });
            } else{
                Toast.info(res.data.msg)
            }
        })
    };
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noMore">
                <p>暂无数据</p>
            </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noMore">
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    render() {
        const _renderRow = (res, index, rowID) => {
            return (
                <div className="mylist" onClick={()=>this.props.history.push(`/fileDetail/${res.id}`)}  key={rowID}>
                    <div className="top">
                        <div className="time">{res.createDate}</div>
                        <div className="dizhi"><span>{res.distance + 'km'}</span> 可见 </div>
                    </div>
                    <div className="con">{res.content}</div>
                    <div className="imglist">
                        {
                            res.photoList && res.photoList.map((res,i)=>(
                                <img src={res} key={i} className={(i+1)%3 === 0? 'margin' : null}/>
                            ))
                        }
                    </div>
                </div>
            )
        };
        return (
            this.state.data.length> 0 ?
                <ListView
                    className="tabsList"
                    ref={el => this.lv = el}
                    dataSource={this.state.dataSource}
                    renderFooter={() => (<div style={{textAlign: 'center'}}>
                        {this.state.isLoading ? '加载中...' : '没有更多'}
                    </div>)}
                    renderRow={_renderRow}
                    style={{
                        height: '100%',
                        overflow: 'auto',
                    }}
                    scrollRenderAheadDistance={300}
                    onEndReached={this._onEndReached}
                    onEndReachedThreshold={30}
                />
                :  (this.notData())

        )

    }
}



// WEBPACK FOOTER //
// ./src/container/MtLife/SoldOut.js